import React, { useState, useEffect } from "react";
import Permiso from "../../router/Permiso";
import { AsistenciaService } from "../../services/AsistenciaService";
import Preloader from "../../components/Preloader";

const ListadoDetallada = ({ token, refreshTrigger = 0 }) => {
    const [asistencias, setAsistencias] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [buscarDocumento, setBuscarDocumento] = useState("");
    const [buscarNombre, setBuscarNombre] = useState("");
    const [buscarEstado, setBuscarEstado] = useState("");
    const [estados, setEstados] = useState([]);
    const [totalRegistros, setTotalRegistros] = useState(0);

    useEffect(() => {
        fetchListadoAsistencia();
        cargarEstados();
    }, [currentPage, fechaInicio, fechaFin, refreshTrigger, buscarDocumento, buscarNombre, buscarEstado]);

    const fetchListadoAsistencia = async () => {
        setLoading(true);
        setError("");
        try {
            const { asistencias, totalPaginas, totalRegistros } = await AsistenciaService.getAsistenciaDetallada({
                token,
                pagina: currentPage,
                pageSize: 20,
                desde: fechaInicio,
                hasta: fechaFin,
                documento: buscarDocumento,
                nombre: buscarNombre,
                estado: buscarEstado
            });

            setAsistencias(asistencias);
            setTotalPages(totalPaginas);
            setTotalRegistros(totalRegistros);
        } catch (err) {
            setError("Error al cargar las asistencia");
            console.error("Error:", err);
        } finally {
            setLoading(false);
        }
    };

    const cargarEstados = async () => {
        try {
            const response = await AsistenciaService.getEstadosAsistencia(token);
            setEstados(response);
        } catch (error) {
            console.error("Error al cargar perfiles:", error);
        }
    };

    const exportarExcel = async () => {
        try {
            setLoading(true);
            const filtros = {
                desde: fechaInicio,
                hasta: fechaFin,
                documento: buscarDocumento,
                nombre: buscarNombre,
                estado: buscarEstado
            };

            const blob = await AsistenciaService.exportarDetalladaExcel(token, filtros);

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "listado_asistencia_detallada.xlsx"; 
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error al exportar Excel:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <Preloader />;

    return (
        <div className="ventas-admin-container">
            <div className="ventas-table-header">
                <h2 className="ventas-table-title">Listado Detallada </h2>
                <div className="productos-actions">
                    <Permiso permiso="exportar_asistencia">
                        <button onClick={exportarExcel} className="btn-exportar">
                            Exportar a Excel
                        </button>
                    </Permiso>
                </div>
            </div>

            {/* Filtros */}
            <div className="usuarios-filtros">
                <div className="filtro-item">
                    <label htmlFor="fecha-inicio">Fecha Inicio:</label>
                    <input
                        type="date"
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.target.value)}
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="fecha-fin">Fecha Fin:</label>
                    <input
                        type="date"
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.target.value)}
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="numero-documento">Número del Documento:</label>
                    <input
                        type="text"
                        value={buscarDocumento}
                        onChange={(e) => setBuscarDocumento(e.target.value)}
                        placeholder="Ingrese número "
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="buscar-por">Buscar por :</label>
                    <input
                        type="text"
                        value={buscarNombre}
                        onChange={(e) => setBuscarNombre(e.target.value)}
                        placeholder="Nombre, apellido o nombre completo"
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="buscarEstado">Estados:</label>
                    <select
                        id="buscarEstado"
                        value={buscarEstado}
                        onChange={(e) => setBuscarEstado(e.target.value)}
                        className="filtro-select"
                    >
                        <option value="">Todos los estados</option>
                        {estados.map((estado) => (
                            <option key={estado.id} value={estado.id}>
                                {estado.descripcion}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="filtro-item">
                    <button
                        onClick={() => {
                            setFechaInicio("");
                            setFechaFin("");
                            setBuscarDocumento("");
                            setBuscarNombre("");
                            setCurrentPage(1);
                            fetchListadoAsistencia();
                        }}
                        className="btn-limpiar"
                    >
                        Limpiar Filtros
                    </button>
                </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            {loading ? (
                <div className="loading">Cargando asistencia...</div>
            ) : (
                <>
                    <div className="ventas-table-wrapper">
                        <table className="ventas-table">
                            <thead>
                                <tr>
                                    <th>Tipo de Documento</th>
                                    <th>Número</th>
                                    <th>Nombres y Apellidos</th>
                                    <th>Supervisor</th>
                                    <th>Perfil</th>
                                    <th>Estado</th>
                                    <th>Fecha</th>
                                    <th>Hora</th>
                                    <th>Min. Tarde</th>
                                </tr>
                            </thead>
                            <tbody>
                                {asistencias.map((asistencia) => {
                                    return (
                                        <tr key={asistencia.id}>
                                            <td>{asistencia.tipo_documento}</td>

                                            <td>{asistencia.numero_documento}</td>
                                            <td>{asistencia.nombres} {asistencia.apellidoPaterno} {asistencia.apellidoMaterno}</td>
                                            <td>{asistencia.nombre_supervisor} {asistencia.apellido_supervisor}</td>
                                            <td>{asistencia.perfil_nombre}</td>
                                            <td>{asistencia.estado_asistencia}</td>
                                            <td>
                                                {new Date(asistencia.fecha_asistencia).toLocaleDateString()}
                                            </td>

                                            <td>{asistencia.hora_asistencia}</td>
                                            <td className="ventas-acciones">{asistencia.minutos_asistencia}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
                        {" "}
                        Total de registros: {totalRegistros}{" "}
                    </span>
                    {/* Paginación */}
                    <div className="pagination">
                        <button
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            Anterior
                        </button>
                        <span>
                            Página {currentPage} de {totalPages}
                        </span>
                        <button
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            Siguiente
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default ListadoDetallada;
